import { Box, Typography } from '@mui/material';
import StudentPronunciationWorkspace from '../component/StudentPronunciationWorkspace';
import VerbaScholaStudentPageContent from '../component/VerbaScholaStudentPageContent';
import { STUDENT_BLUE_TEXT, STUDENT_INTER, STUDENT_NAVY, STUDENT_POPPINS, STUDENT_SLATE } from '../style/verbaScholaStudentStyles';

/** Responsive pronunciation mockup composition backed by the real sentence and scoring APIs. */
export default function VerbaScholaStudentPronunciationPage() {
    return <VerbaScholaStudentPageContent maxWidth={1320}>
        <Typography sx={{ fontFamily: STUDENT_INTER, fontWeight: 700, fontSize: 11, letterSpacing: '.09em', color: STUDENT_BLUE_TEXT }}>PRACTICE</Typography>
        <Typography component="h1" sx={{ mt: 0.5, fontFamily: STUDENT_POPPINS, fontWeight: 600, fontSize: { xs: 25, md: 30 }, color: STUDENT_NAVY }}>Pronunciation</Typography>
        <Typography sx={{ mt: 0.4, fontFamily: STUDENT_INTER, fontSize: 14, color: STUDENT_SLATE }}>Build your sentence list, listen to the model, and review your recordings.</Typography>
        <Box sx={{ mt: 3 }}>
            <StudentPronunciationWorkspace />
        </Box>
    </VerbaScholaStudentPageContent>;
}
